import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CtaButtonProps {
  text?: string;
  subtext?: string;
  className?: string;
  onClick?: () => void;
  href?: string;
}
export function CtaButton({
  text = 'COMPRAR AHORA',
  subtext,
  className = '',
  onClick,
  href = 'https://libroalclick.shop/cart/47737801179395:1'
}: CtaButtonProps) {
  const content = <div className="flex flex-col items-center justify-center" data-id="element-23">
      <div className="flex items-center gap-2 text-xl md:text-2xl font-black tracking-wide uppercase text-white drop-shadow-md" data-id="element-24">
        {text}
        <ArrowRight className="w-6 h-6 md:w-8 md:h-8 animate-pulse" data-id="element-25" />
      </div>
      {subtext && <span className="text-xs md:text-sm font-medium text-amber-100 opacity-90 mt-1" data-id="element-26">
          {subtext}
        </span>}
    </div>;
  const buttonClasses = `
    relative group overflow-hidden
    bg-gradient-to-b from-amber-400 via-amber-500 to-orange-600
    hover:from-amber-300 hover:via-amber-400 hover:to-orange-500
    border-t border-amber-300 border-b-4 border-b-orange-800
    rounded-lg shadow-[0_0_20px_rgba(245,158,11,0.3)] hover:shadow-[0_0_30px_rgba(245,158,11,0.5)]
    px-8 py-4 md:px-12 md:py-5
    transition-all duration-200 transform hover:-translate-y-1 active:translate-y-0 active:border-b-0
    w-full md:w-auto max-w-md mx-auto
    ${className}
  `;
  if (href) {
    return <motion.a href={href} className={buttonClasses} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} data-id="element-27">
        {content}
      </motion.a>;
  }
  return <motion.button onClick={onClick} className={buttonClasses} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} data-id="element-28">
      {content}
    </motion.button>;
}